import { render } from "./page9.vue?vue&type=template&id=4a3da3bc&scoped=true"
import script from "./page9.vue?vue&type=script&lang=js"
export * from "./page9.vue?vue&type=script&lang=js"

import "./page9.vue?vue&type=style&index=0&id=4a3da3bc&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3da3bc"]])

export default __exports__